import styled from 'styled-components';

import { media } from '@theme/mixins';
import colors from '@theme/colors';

export const FormWrap = styled.div`
  &.ltr {
    .honey {
      left: -5000px;
    }
  }
  &.rtl {
    .honey {
      left: 5000px;
    }
  }
`;

export const Form = styled.form``;

export const ButtonWrap = styled.div``;
